import script from "./kaojiang_store.vue?vue&type=script&setup=true&lang=js"
export * from "./kaojiang_store.vue?vue&type=script&setup=true&lang=js"

import "./kaojiang_store.vue?vue&type=style&index=0&id=10f02fc2&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10f02fc2"]])

export default __exports__